// src/components/calendar/CalendarHeader.jsx
import React from 'react';
import { Tabs, Tab, Button, Typography } from '@mui/material';
import { NavigateBefore as PreviousIcon, NavigateNext as NextIcon, Today as TodayIcon } from '@mui/icons-material';

const CalendarHeader = ({ view, setView, currentDate, setCurrentDate }) => {
    const handlePrevious = () => {
        const newDate = new Date(currentDate);
        if (view === 'month') {
            newDate.setMonth(currentDate.getMonth() - 1);
        } else {
            newDate.setDate(currentDate.getDate() - 7);
        }
        setCurrentDate(newDate);
    };

    const handleNext = () => {
        const newDate = new Date(currentDate);
        if (view === 'month') {
            newDate.setMonth(currentDate.getMonth() + 1);
        } else {
            newDate.setDate(currentDate.getDate() + 7);
        }
        setCurrentDate(newDate);
    };

    const handleToday = () => {
        setCurrentDate(new Date());
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Tabs value={view} onChange={(e, newValue) => setView(newValue)}>
                <Tab label="Month" value="month" />
                <Tab label="Week" value="week" />
            </Tabs>
            <div style={{ display: 'flex', gap: '8px' }}>
                <Button variant="outlined" startIcon={<PreviousIcon />} onClick={handlePrevious}>
                    Anterior
                </Button>
                <Button variant="outlined" startIcon={<TodayIcon />} onClick={handleToday}>
                    Hoy
                </Button>
                <Button variant="outlined" endIcon={<NextIcon />} onClick={handleNext}>
                    Siguiente
                </Button>
            </div>
        </div>
    );
};

export default CalendarHeader;
